export const isStrongPassword = (pw) => (pw || "").length >= 8 && /[A-Za-z]/.test(pw) && /\d/.test(pw);

const score = (pw) => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (/[A-Za-z]/.test(pw) && /\d/.test(pw)) s++;
  if (pw.length >= 12) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return s;
};

const LEVELS = [
  { label: "", color: "" },
  { label: "Weak", color: "bg-danger" },
  { label: "Fair", color: "bg-warning" },
  { label: "Good", color: "bg-info" },
  { label: "Strong", color: "bg-success" },
];

export function PasswordStrength({ value }) {
  const s = score(value);
  const meets = isStrongPassword(value);
  return (
    <div className="space-y-1.5" data-testid="password-strength">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors ${i <= s ? LEVELS[s].color : "bg-muted"}`} />
        ))}
      </div>
      <p className={`text-xs ${meets ? "text-muted-foreground" : "text-danger"}`} data-testid="password-strength-label">
        {value ? (meets
          ? `${LEVELS[s].label} · meets requirements`
          : "Use at least 8 characters with both letters and numbers")
          : "Use at least 8 characters with both letters and numbers"}
      </p>
    </div>
  );
}
